export default __webpack_public_path__ + "img/img_hien-db4491efb6a426f808897d9c12385e8a.jpg";